import { render, staticRenderFns } from "./accountBase.vue?vue&type=template&id=44c4c0be&"
import script from "./accountBase.vue?vue&type=script&lang=js&"
export * from "./accountBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports